import { UIData } from '../../hooks/stores/uiStore';

interface ElementSelectionDependencies {
  UIData: UIData;
  setUIData: (data: Partial<UIData>) => void;
}

export function createElementSelectionUtils({
  UIData,
  setUIData,
}: ElementSelectionDependencies) {
  const selectElement = (id: string) => {
    setUIData({ selectedElementIDs: [...UIData.selectedElementIDs, id] });
    unhoverElement(id);
  };

  const selectOneElement = (id: string) => {
    setUIData({ selectedElementIDs: [id] });
    unhoverElement(id);
  };

  const deselectElement = (id: string) =>
    setUIData({
      selectedElementIDs: [
        ...UIData.selectedElementIDs.filter((el) => el !== id),
      ],
    });

  const deselectAllElements = () => setUIData({ selectedElementIDs: [] });

  const hoverElement = (id: string) =>
    setUIData({
      hoveredLauncherElementIDs: [...UIData.hoveredLauncherElementIDs, id],
    });

  const hoverOneElement = (id: string) =>
    setUIData({ hoveredLauncherElementIDs: [id] });

  const unhoverElement = (id: string) =>
    setUIData({
      hoveredLauncherElementIDs: [
        ...UIData.hoveredLauncherElementIDs.filter((el) => el !== id),
      ],
    });

  const unhoverAllElements = () => setUIData({ hoveredLauncherElementIDs: [] });

  return {
    selectElement,
    selectOneElement,
    deselectElement,
    deselectAllElements,
    hoverElement,
    hoverOneElement,
    unhoverElement,
    unhoverAllElements,
  };
} 